import type { StageKpi } from "../../api/workflow";
import { breachTone, ownerLabel } from "./labels";

/** The stages in order, as one strip: who owns each, how long it may take,
 * how many jobs are sitting in it now, and how often it runs over. A stage
 * with no SLA says so rather than showing a zero that reads as "never late". */
export function StageStrip({ stages }: { stages: StageKpi[] }) {
  return (
    <ol className="stage-strip" aria-label="Stages">
      {stages.map((s) => {
        const tone = breachTone(s.breach_rate);
        const pct = s.breach_rate === null ? 0 : Math.round(s.breach_rate * 100);
        return (
          <li
            key={s.stage}
            className={`stage-cell tone-${tone}`}
            title={`${s.started} started · ${s.completed} completed${s.median_days === null ? "" : ` · median ${s.median_days} days`}`}
          >
            <div className="stage-title">
              <span className="stage-num">{s.stage}</span>
              <span className="stage-label">{s.label}</span>
            </div>
            <span className="stage-meta">
              {ownerLabel(s.owner)} · {s.sla_days === null ? "no SLA" : `${s.sla_days} day SLA`}
            </span>
            <span className="stage-waiting">
              <strong>{s.waiting}</strong> waiting
            </span>
            <span className="stage-meter" aria-hidden="true">
              <span style={{ width: `${pct}%` }} />
            </span>
            <span className="stage-breach">
              {s.sla_days === null
                ? "nothing to breach"
                : s.breach_rate === null
                  ? "none started"
                  : `${pct}% breached`}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
